export default __webpack_public_path__ + "static/media/TDOGE-BNB.de648360.svg";